var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1ArrRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.973079 0.00103179C0.746117 0.000771457 0.526163 0.0471682 0.351402 0.132169C0.253043 0.180034 0.171737 0.238819 0.112142 0.305156C0.0525462 0.371493 0.015832 0.444078 0.00410183 0.518756C-0.00762831 0.593435 0.00585629 0.668738 0.043783 0.740352C0.0817096 0.811967 0.143332 0.878487 0.225124 0.9361L0.325833 1.00682C2.41124 2.47133 2.43911 5.55196 0.380544 7.05396C0.299857 7.11228 0.239601 7.17939 0.203241 7.25142C0.166881 7.32346 0.155133 7.399 0.168673 7.47371C0.182213 7.54841 0.220774 7.62082 0.282139 7.68675C0.343504 7.75268 0.426464 7.81084 0.52625 7.85789C0.626753 7.9098 0.74445 7.94895 0.871955 7.97289C0.999459 7.99683 1.13402 8.00504 1.26719 7.99701C1.40035 7.98898 1.52926 7.96488 1.6458 7.92622C1.76235 7.88757 1.86403 7.83519 1.94445 7.77237L6.63617 4.35138C6.77904 4.24936 6.85714 4.12139 6.85714 3.98933C6.85714 3.85726 6.77904 3.7293 6.63617 3.62727L1.77932 0.206291C1.68187 0.137291 1.55809 0.0827468 1.41801 0.0470842C1.27792 0.0114211 1.12549 -0.00435648 0.973079 0.00103179Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1ArrRight);
export default __webpack_public_path__ + "static/media/1arr-right.bd5a47b8b81852b835bbd14666731807.svg";
export { ForwardRef as ReactComponent };